import styled from "styled-components";

export const SOnboardingTemplatesTemplateImage = styled.img`
  height: 200px;
  width: 100%;
  border-bottom: 1px solid var(--ui-03);
  object-fit: cover;
`;
